export const FSM_OPEN_SETTINGS = "FSM_OPEN_SETTINGS";
